class PasswordChangedUsersController {
  static controller($scope, $state) {
    'ngInject';

    $scope.email = $state.params.email;
  };
}

export default PasswordChangedUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/password-changed.users.controller.js